import React from "react";
import { Link } from "react-router-dom";

export default function QALibraryFilter({ libraryId, status, children }){
	return (
		<Link to={{
			pathname:`/library/${libraryId}/`,
			state:{
				initialFilters: [{
					column:"approval",
					params:status,
				}],
			},
		}}>
			{children}
		</Link>
	);
}

QALibraryFilter.displayName = "QALibraryFilter";
QALibraryFilter.defaultProps = {
	status:["QA"],
	libraryId:-1,
};
